import store from './apps/store/store'
import { clearState } from './apps/store/byoSlice'

// React Apps
import './apps/cart/index.jsx'
import './apps/product-tiles/index.jsx'

// Components
import { setupInlineCart } from './components/InlineCart.js'

// Sections
import { setupCart } from './sections/cart.js'
import { setupAnnouncementBar } from './sections/announcement-bar.js'

document.addEventListener('DOMContentLoaded', () => {
  // Sections
  setupAnnouncementBar()
  setupCart()

  // Components
  setupInlineCart()

  const byoContainer = document.querySelector('#BuildYourOwn')
  if(!byoContainer) {
    store.dispatch(clearState())
  }
})